import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { FeedbackAPI } from 'api/feedback';

export interface ContentFeedback {
  id: number;
  sourceType: string;
  sourceId: number;
  feedback: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export const useCreateFeedbackMutation = (
  queryOptions?: Omit<
    UseMutationOptions<
      void,
      Error,
      {
        sourceType: string;
        feedbackType: any;
        sourceId: string;
        feedbackComment?: string;
      }
    >,
    'mutationFn' | 'onSuccess'
  >,
): UseMutationResult<
  void,
  Error,
  {
    sourceType: string;
    feedbackType: any;
    sourceId: string;
    feedbackComment?: string;
  }
> => {
  return useMutation({
    mutationFn: (payload) => FeedbackAPI.createFeedback(payload),
    ...queryOptions,
  });
};

export const useUpdateFeedbackMutation = (
  queryOptions?: Omit<
    UseMutationOptions<
      void,
      Error,
      {
        sourceType: string;
        feedbackType: any;
        sourceId: string;
        feedbackId: number;
        feedbackComment?: string;
      }
    >,
    'mutationFn' | 'onSuccess'
  >,
): UseMutationResult<
  void,
  Error,
  {
    sourceType: string;
    feedbackType: any;
    sourceId: string;
    feedbackId: number;
    feedbackComment?: string;
  }
> => {
  return useMutation({
    mutationFn: (payload) => FeedbackAPI.updateFeedback(payload),
    ...queryOptions,
  });
};

export const useDeleteFeedbackMutation = (
  queryOptions?: Omit<
    UseMutationOptions<
      void,
      Error,
      {
        feedbackId: number;
      }
    >,
    'mutationFn' | 'onSuccess'
  >,
): UseMutationResult<
  void,
  Error,
  {
    feedbackId: number;
  }
> => {
  return useMutation({
    mutationFn: (payload) => FeedbackAPI.deleteFeedback(payload),
    ...queryOptions,
  });
};

export const useGetDocumentFeedbackQuery = (
  sourceType: string,
  sourceId: string,
  queryOptions?: Omit<UseQueryOptions<any[], Error>, 'queryKey' | 'queryFn'>,
): UseQueryResult<any[], Error> => {
  return useQuery({
    queryKey: ['documentFeedback', sourceType, sourceId],
    queryFn: async () => {
      return FeedbackAPI.getAllFeedbacks({
        sourceType,
        sourceId,
      });
    },
    ...queryOptions,
  });
};
